import type { Util } from '../../../types/util';

const baseButton: Util.VariantCSSKeys<ButtonVariantsType> = {
  small: {
    height: '40px',
    width: '40px',
    padding: '12px',
  },
  medium: {
    height: '50px',
    width: '50px',
    padding: '15px',
  },
  large: {
    height: '80px',
    width: '80px',
    padding: '24px',
  },
};

const button: Util.VariantKeyModes<ButtonVariantsType> = {
  products: {
    chart: baseButton,
    chartblog: baseButton,
    co: baseButton,
    edu: baseButton,
    scale: baseButton,
    spark: baseButton,
  },
};

export type ButtonVariantsType = 'small' | 'medium' | 'large';
export const buttonVariants = Object.keys(baseButton) as ButtonVariantsType[];

export default button;
